export default function componentStyleOverrides(mode, theme) {
    const bgColor = mode === theme.colors?.grey50;

    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '4px'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: theme.darkTextLink,
                    '&.Mui-checked': {
                        color: theme.darkTextLink
                    }
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.primaryMedium,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.primaryMedium,
                    '&.Mui-focused': {
                        color: theme.primarySaturated
                    }
                },
                shrink: {
                    color: theme.primaryMedium,
                    '&.Mui-focused': {
                        color: theme.primarySaturated
                    }
                },
                outlined: {
                    color: theme.primaryMedium,
                    '&.Mui-focused': {
                        color: theme.primarySaturated
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    color: theme.textDark,
                    background: theme.fieldBackground,
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.Mui-focused': {
                        color: theme.textDark
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.primaryMedium
                    },
                    '&:hover $notchedOutline': {
                        borderColor: '#000000 !important'
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        color: theme.textDark,
                        borderColor: theme.primarySaturated
                    },
                    '&.Mui-focused .MuiOutlinedInput-input': {
                        backgroundColor: theme.fieldSelectBackground
                    }
                },
                input: {
                    fontWeight: 500,
                    color: theme.textDark,
                    background: theme.fieldBackground,
                    padding: '15.5px 14px',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: theme.darkTextLink,
                    '&.Mui-checked': {
                        color: theme.darkTextLink
                    }
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    '&:focus': {
                        backgroundColor: 'transparent'
                    }
                },
                icon: {
                    fill: theme.darkTextLink
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.darkTextPrimary
                }
            }
        }
    };
}
